"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = require("react-redux");

var _underscore = require("underscore");

var _underscore2 = _interopRequireDefault(_underscore);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _Button = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Button");

var _Button2 = _interopRequireDefault(_Button);

var _Tabs = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Tabs");

var _Tabs2 = _interopRequireDefault(_Tabs);

var _Hr = require("@quixeltools/quixel-ui-library/dist/components/common/website/Hr");

var _Hr2 = _interopRequireDefault(_Hr);

var _payments = require("redux/modules/payments");

var _customer = require("redux/modules/customer");

var _zendesk = require("../../redux/modules/zendesk");

var _email = require("redux/modules/email");

var _utils = require("../../utils");

var _components = require("components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaymentWizard = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    subscription: state.user.subscription,
    subscriptionSwitchedFrom: state.user.subscriptionSwitchedFrom,
    seatsForSubscription: state.subscriptions.seatsForSubscription,
    customer: state.customer.customer,
    error: state.customer.error || state.customer.createError,
    currentPayment: state.payments.currentPayment,
    userEmail: state.user.email,
    zendesk: state.zendesk,
    price: state.payments.price,
    clientToken: state.payments.clientToken
  };
}, {
  getCustomer: _customer.getCustomer,
  initPayment: _payments.initPayment,
  getPrice: _payments.getPrice,
  submitPayment: _payments.submitPayment,
  paypalNonce: _payments.paypalNonce,
  teardownPayment: _payments.teardownPayment,
  purchaseWithExistingPaymentMethod: _payments.purchaseWithExistingPaymentMethod,
  emailSubscribe: _email.subscribe,
  createTicket: _zendesk.createTicket,
  creditCardNonce: _payments.creditCardNonce
}), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(PaymentWizard, _React$Component);

  function PaymentWizard(props) {
    (0, _classCallCheck3.default)(this, PaymentWizard);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PaymentWizard.__proto__ || (0, _getPrototypeOf2.default)(PaymentWizard)).call(this, props));

    _this.renderPaymentForm = _this.renderPaymentForm.bind(_this);
    _this.renderFinalScreen = _this.renderFinalScreen.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.setCreditCardState = _this.setCreditCardState.bind(_this);
    _this.handleSubmitOnSavedPayment = _this.handleSubmitOnSavedPayment.bind(_this);
    _this.handlePayPalPrepare = _this.handlePayPalPrepare.bind(_this);
    _this.handleCreditCardPrepare = _this.handleCreditCardPrepare.bind(_this);
    _this.setPayPalState = _this.setPayPalState.bind(_this);
    _this.handleCountryChange = _this.handleCountryChange.bind(_this);
    _this.handleBillingDetailsChangeClick = _this.handleBillingDetailsChangeClick.bind(_this);
    _this.handlePaymentDetailsChangeClick = _this.handlePaymentDetailsChangeClick.bind(_this);
    _this.updatePrice = _underscore2.default.debounce(_this.updatePrice.bind(_this), 1000);
    _this.handleCaptchaChange = _this.handleCaptchaChange.bind(_this);

    _this.state = {
      paymentType: "",
      customerAlreadyExists: false,
      submiting: false,
      countryCode: "US"
    };
    return _this;
  }

  (0, _createClass3.default)(PaymentWizard, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.initPayment(this.props.paymentItem);

      if (this.props.customer) this.setState({ customerAlreadyExists: true });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (!this.state.customerAlreadyExists && this.props.currentPayment.makingPayment && !nextProps.currentPayment.makingPayment && (this.props.customer || nextProps.customer)) {
        if (!this.state.customerAlreadyExists) {
          this.setState({ customerAlreadyExists: true });
        }
      }
    }
  }, {
    key: "handleBillingDetailsChangeClick",
    value: function handleBillingDetailsChangeClick(ev) {
      ev.stopPropagation();
      ev.preventDefault();
      this.context.dialogs.custom(_react2.default.createElement(_components.AddressSettingsPopup, null));
    }
  }, {
    key: "handlePaymentDetailsChangeClick",
    value: function handlePaymentDetailsChangeClick(ev) {
      ev.stopPropagation();
      ev.preventDefault();
      this.context.dialogs.custom(_react2.default.createElement(_components.PaymentSettingsPopup, null));
    }
  }, {
    key: "handleCaptchaChange",
    value: function handleCaptchaChange(value) {
      var paymentType = this.state.paymentType;


      if (value && paymentType === "pay-pal") {
        this.handlePayPalPrepare();
      } else if (value && paymentType === "cc") {
        //Plus check if  nonce is  present or not
        this.handleCreditCardPrepare();
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.state.paymentType !== nextState.paymentType) {
        return true;
      }
      if (!this.state.customerAlreadyExists && this.props.currentPayment.makingPayment && !nextProps.currentPayment.makingPayment && (this.props.customer || nextProps.customer)) {
        return true;
      }
      if (this.props.customer !== nextProps.customer) {
        var _nextProps$customer = nextProps.customer,
            countryCode = _nextProps$customer.countryCode,
            state = _nextProps$customer.state,
            city = _nextProps$customer.city,
            postalCode = _nextProps$customer.postalCode,
            vatNo = _nextProps$customer.vatNo,
            isVatValid = _nextProps$customer.isVatValid;

        this.updatePrice(countryCode, state, city, postalCode, vatNo, !!vatNo);
        return true;
      }
      if (this.state.customerAlreadyExists !== nextState.customerAlreadyExists) {
        return true;
      }
      if (this.props.currentPayment.makingPayment !== nextProps.currentPayment.makingPayment) {
        return true;
      }
      if (this.props.currentPayment.done !== nextProps.currentPayment.done) {
        return true;
      }
      if (this.props.currentPayment.paypalEmail !== nextProps.currentPayment.paypalEmail) {
        return true;
      }
      if (this.props.clientToken !== nextProps.clientToken) {
        return true;
      }
      return false;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var teardownPayment = this.props.teardownPayment;


      teardownPayment();
    }
  }, {
    key: "showContactBox",
    value: function showContactBox() {
      this.context.dialogs.custom(_react2.default.createElement(_components.ContactBox, { title: "Payment Issues", message: "" }));
    }
  }, {
    key: "getPaymentLine",
    value: function getPaymentLine(_ref) {
      var cardLast4 = _ref.cardLast4,
          paypalEmail = _ref.paypalEmail;

      return cardLast4 ? "Credit card ending with " + cardLast4 : "PayPal account: " + paypalEmail;
    }
  }, {
    key: "renderFinalScreen",
    value: function renderFinalScreen() {
      var _props = this.props,
          userEmail = _props.userEmail,
          paymentSuccessTo = _props.paymentSuccessTo,
          subscriptionSwitchedFrom = _props.subscriptionSwitchedFrom;
      var _props$subscription = this.props.subscription,
          createdAt = _props$subscription.createdAt,
          expiresAt = _props$subscription.expiresAt;
      var _props$currentPayment = this.props.currentPayment,
          values = _props$currentPayment.values,
          cardLast4 = _props$currentPayment.cardLast4,
          paypalEmail = _props$currentPayment.paypalEmail,
          paymentItem = _props$currentPayment.paymentItem;


      var license = paymentItem && Object.prototype.hasOwnProperty.call(paymentItem, "license") && paymentItem.license;

      var name = values.name,
          company = values.company,
          address = values.address,
          address2 = values.address2,
          postalCode = values.postalCode,
          city = values.city,
          country = values.country,
          state = values.state;


      if (!cardLast4 && !paypalEmail) {
        // Payment was made through saved payment method
        cardLast4 = this.props.customer.paymentMethod.last4;
        paypalEmail = this.props.customer.paymentMethod.email;
      }

      // license signifies that user is buying a subscription
      createdAt = license && createdAt ? (0, _moment2.default)(createdAt).format("dddd DD MMM YYYY") : null;
      expiresAt = license && expiresAt ? (0, _moment2.default)(expiresAt).format("dddd DD MMM YYYY") : null;

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(_components.CheckoutSummary, {
          icon: "https://d3uwib8iif8w1p.cloudfront.net/megascans/icons/bridge_icon_2048_preview.png",
          icon1: "https://d3uwib8iif8w1p.cloudfront.net/megascans/icons/mixer_icon_2048_preview.png",
          email: userEmail,
          name: name,
          address: address,
          address2: address2,
          postalCode: postalCode,
          city: city,
          state: state,
          country: country,
          paymentLine: this.getPaymentLine({ cardLast4: cardLast4, paypalEmail: paypalEmail }),
          subscriptionCreatedAt: createdAt,
          subscriptionNextChargeAt: expiresAt
        }),
        _react2.default.createElement(_Hr2.default, { className: (0, _glamor.css)({ marginTop: "3em", marginBottom: "3em" }) }),
        _react2.default.createElement(_Button2.default, {
          to: paymentSuccessTo,
          className: (0, _glamor.css)({ float: "right" }),
          mode: "secondary",
          label: "Browse Megascans"
        })
      );
    }
  }, {
    key: "updatePrice",
    value: function updatePrice(countryCode, state, city, postalCode, vatNo, isVatValid) {
      var _props2 = this.props,
          amount = _props2.amount,
          getPrice = _props2.getPrice,
          discountedPrice = _props2.discountedPrice,
          seatsForSubscription = _props2.seatsForSubscription,
          transactionType = _props2.transactionType;


      getPrice((0, _extends3.default)({
        transactionType: transactionType,
        countryCode: countryCode || "US",
        state: state,
        postalCode: postalCode,
        price: seatsForSubscription ? typeof discountedPrice !== "undefined" && discountedPrice !== null ? discountedPrice * seatsForSubscription : amount : typeof discountedPrice !== "undefined" && discountedPrice !== null ? discountedPrice : amount
      }, vatNo && isVatValid && {
        vatNo: vatNo
      }));
    }
  }, {
    key: "setPayPalState",
    value: function setPayPalState() {
      this.setState({
        paymentType: "pay-pal"
      });

      this.handlePayPalPrepare();
    }
  }, {
    key: "setCreditCardState",
    value: function setCreditCardState() {
      this.setState({
        paymentType: "cc"
      });
      //this.handleCreditCardPrepare();
    }
  }, {
    key: "renderCustomerScreen",
    value: function renderCustomerScreen(makingPayment) {
      var _this2 = this;

      var _props3 = this.props,
          customer = _props3.customer,
          singleUse = _props3.singleUse;
      var name = customer.name,
          postalCode = customer.postalCode,
          country = customer.country,
          countryCode = customer.countryCode,
          company = customer.company,
          address1 = customer.address1,
          address2 = customer.address2,
          vatNo = customer.vatNo,
          state = customer.state,
          city = customer.city,
          _customer$paymentMeth = customer.paymentMethod,
          last4 = _customer$paymentMeth.last4,
          expirationDate = _customer$paymentMeth.expirationDate,
          email = _customer$paymentMeth.email,
          paymentMethodInstrument = _customer$paymentMeth.paymentMethodInstrument;

      var billingDetails = {
        name: name,
        postalCode: postalCode,
        country: country,
        countryCode: countryCode,
        company: company,
        address1: address1,
        address2: address2,
        vatNo: vatNo,
        state: state,
        city: city
      };
      var paymentDetails = paymentMethodInstrument === "paypal" ? { email: email } : { last4: last4, expirationDate: expirationDate };

      return _react2.default.createElement(_components.SavedPaymentDetailsForm, {
        singleUse: singleUse,
        billingDetails: billingDetails,
        paymentDetails: paymentDetails,
        makingPayment: makingPayment,
        handleBillingDetailsChangeClick: this.handleBillingDetailsChangeClick,
        handlePaymentDetailsChangeClick: this.handlePaymentDetailsChangeClick,
        showPromoCode: !!this.props.paymentItem.license,
        isAnnualSubscription: false //{this.props.paymentItem.billing === 'annual'}
        , promoCodeMessage: this.props.currentPayment && this.props.currentPayment.promoCode && this.props.currentPayment.promoCode.message,
        updatePrice: this.updatePrice,
        backLink: this.props.backLink,
        renderCaptcha: function renderCaptcha(field) {
          return _react2.default.createElement(_components.Captcha, { field: field, onChange: _this2.handleCaptchaChange });
        },
        onSubmit: this.handleSubmitOnSavedPayment,
        handleSubmit: this.handleSubmit
      });
    }
  }, {
    key: "renderPaymentForm",
    value: function renderPaymentForm(makingPayment) {
      var _this3 = this;

      return _react2.default.createElement(_components.PaymentForm, {
        initialValues: {
          paymentMethod: "cc",
          country: "US",
          state: "Alabama",
          city: "",
          subscribe: false
        },
        _error: this.props.error ? this.props.error.msg || this.props.error.message : null,
        paypalContainerId: "paypal-container",
        paypalEmail: this.props.currentPayment.paypalEmail,
        paypalConfirmationHelpText: "To pay, press Confirm Purchase below",
        makingPayment: makingPayment,
        onPayPalPrepare: this.setPayPalState,
        onCountryChange: this.handleCountryChange,
        onSubmit: this.handleSubmit,
        showPromoCode: !!this.props.paymentItem.license,
        isAnnualSubscription: false //{this.props.paymentItem.billing === 'annual'}
        , promoCodeMessage: this.props.currentPayment && this.props.currentPayment.promoCode && this.props.currentPayment.promoCode.message,
        paymentLogosSrc: "/icons/payment-icons.png",
        braintreeLink: "https://www.braintreegateway.com/merchants/2mgdr37qhn27xsmy/verified",
        backLink: this.props.backLink,
        updatePrice: this.updatePrice,
        renderCaptcha: function renderCaptcha(field) {
          return _react2.default.createElement(_components.Captcha, { field: field, onChange: _this3.handleCaptchaChange });
        },
        setCreditCardState: this.setCreditCardState,
        creditCardPrepare: this.handleCreditCardPrepare,
        paypalPaymentBoxError: this.props.clientToken.error
      });
    }
  }, {
    key: "handleSubmitOnSavedPayment",
    value: function handleSubmitOnSavedPayment() {
      var _props$customer = this.props.customer,
          name = _props$customer.name,
          country = _props$customer.country,
          countryCode = _props$customer.countryCode,
          address = _props$customer.address1,
          address2 = _props$customer.address2,
          postalCode = _props$customer.postalCode,
          state = _props$customer.state,
          city = _props$customer.city;


      return this.props.purchaseWithExistingPaymentMethod({
        values: !state || state === "" ? { name: name, country: country, countryCode: countryCode, address: address, city: city, postalCode: postalCode } : { name: name, country: country, countryCode: countryCode, address: address, city: city, state: state, postalCode: postalCode },
        singleUse: this.props.singleUse,
        paymentActionCreator: this.props.paymentActionCreator,
        amount: typeof this.props.discountedPrice !== "undefined" && this.props.discountedPrice !== null ? this.props.discountedPrice : this.props.amount
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(values) {
      var _this4 = this;

      var license = this.props.currentPayment.paymentItem.license;
      var cacheMessage = this.props.zendesk.cacheMessage;


      this.setState({
        message: null,
        submiting: true
      });

      setTimeout(function () {
        return _this4.props.submitPayment({
          values: values.country !== "US" ? (0, _extends3.default)({}, _ramda2.default.omit(["state"], values)) : values,
          singleUse: _this4.props.singleUse,
          paymentActionCreator: _this4.props.paymentActionCreator,
          amount: typeof _this4.props.discountedPrice !== "undefined" && _this4.props.discountedPrice !== null ? _this4.props.discountedPrice : _this4.props.amount
        }).then(function (obj) {
          if (values.subscribe) {
            _this4.props.emailSubscribe();
          }
          if (license === "educational" && typeof cacheMessage.email !== "undefined") {
            var cmt = cacheMessage.comment.split("\n");
            cmt[2] = "Duration " + _this4.props.paymentItem.billingCycle;
            cmt = cmt.join("\n");
            cacheMessage.comment = cmt;

            _this4.props.createTicket(cacheMessage);
          }

          window.localStorage.setItem("firstSubscribe", true);

          var price = _this4.props.price;
          var subscription = obj.user.subscription;


          if (ga) {
            ga("require", "ecommerce");

            var id = (0, _utils.UUIDv4)();

            ga("ecommerce:addTransaction", {
              id: id,
              revenue: price.price,
              tax: price.vatAmount
            });

            ga("ecommerce:addItem", {
              id: id,
              name: subscription.planName,
              sku: subscription.planId,
              category: subscription.license,
              price: _this4.props.amount,
              quantity: 1
            });

            ga("ecommerce:send");
            ga("ecommerce:clear");
          }
          _this4.setState({
            submiting: false
          });
        });
      }, 2000);
    }
  }, {
    key: "handlePayPalPrepare",
    value: function handlePayPalPrepare() {
      var _props4 = this.props,
          amount = _props4.amount,
          currency = _props4.currency,
          singleUse = _props4.singleUse,
          discountedPrice = _props4.discountedPrice;
      var countryCode = this.state.countryCode;


      this.props.paypalNonce({
        container: "paypal-container",
        singleUse: singleUse,
        amount: typeof discountedPrice !== "undefined" && discountedPrice !== null ? discountedPrice : amount,
        currency: currency,
        countryCode: countryCode
      });
    }
  }, {
    key: "handleCreditCardPrepare",
    value: function handleCreditCardPrepare() {
      // Skip re-rendering of credit card fields, if captcha got expire.
      var elem = document.getElementById("braintree-hosted-field-number");
      var countryCode = this.state.countryCode;

      if (!elem) {
        this.props.creditCardNonce({ countryCode: countryCode });
      }
    }
  }, {
    key: "handleCountryChange",
    value: function handleCountryChange(countryCode) {
      var _props5 = this.props,
          amount = _props5.amount,
          seatsForSubscription = _props5.seatsForSubscription,
          discountedPrice = _props5.discountedPrice,
          transactionType = _props5.transactionType;

      var price = seatsForSubscription ? typeof discountedPrice !== "undefined" && discountedPrice !== null ? discountedPrice * seatsForSubscription : amount : typeof discountedPrice !== "undefined" && discountedPrice !== null ? discountedPrice : amount;
      this.props.getPrice({ transactionType: transactionType, countryCode: countryCode, price: price });
      this.props.creditCardNonce({ countryCode: countryCode });
      this.setState({
        countryCode: countryCode
      });
      if (window) {
        if (window["grecaptcha"]) {
          window.grecaptcha.reset();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props$currentPayment2 = this.props.currentPayment,
          done = _props$currentPayment2.done,
          makingPayment = _props$currentPayment2.makingPayment;
      var _props6 = this.props,
          singleUse = _props6.singleUse,
          customer = _props6.customer;
      var customerAlreadyExists = this.state.customerAlreadyExists;


      if (customer && !done) {
        if (singleUse) {
          return _react2.default.createElement(
            _Tabs2.default,
            null,
            _react2.default.createElement(
              _Tabs.Tab,
              { label: "Use Saved Details" },
              this.renderCustomerScreen(makingPayment)
            ),
            _react2.default.createElement(
              _Tabs.Tab,
              { label: "Use One-time Details" },
              this.renderPaymentForm(makingPayment)
            )
          );
        } else if (!customerAlreadyExists) {
          return this.renderPaymentForm(makingPayment);
        } else {
          return this.renderCustomerScreen(makingPayment);
        }
      } else if (!done) {
        return this.renderPaymentForm(makingPayment);
      } else {
        return this.renderFinalScreen();
      }
    }
  }]);
  return PaymentWizard;
}(_react2.default.Component), _class2.contextTypes = {
  dialogs: _react2.default.PropTypes.object
}, _class2.propTypes = {
  singleUse: _react2.default.PropTypes.bool,
  amount: _react2.default.PropTypes.number.isRequired,
  discountedPrice: _react2.default.PropTypes.number,
  seatsForSubscription: _react2.default.PropTypes.number,
  currency: _react2.default.PropTypes.string.isRequired,
  paymentActionCreator: _react2.default.PropTypes.func.isRequired,
  paymentSuccessTo: _react2.default.PropTypes.string.isRequired,
  onPaymentMethodSave: _react2.default.PropTypes.func,
  showEmailSubscribe: _react2.default.PropTypes.bool,
  backLink: _react2.default.PropTypes.string,
  paymentItem: _react2.default.PropTypes.any.isRequired,
  getPrice: _react2.default.PropTypes.func.isRequired,
  initPayment: _react2.default.PropTypes.func.isRequired,
  getCustomer: _react2.default.PropTypes.func.isRequired,
  creditCardNonce: _react2.default.PropTypes.func.isRequired
}, _class2.defaultProps = {
  singleUse: false,
  allowCustomerEdit: true,
  showEmailSubscribe: true,
  paymentCallback: null,
  backLink: null
}, _temp)) || _class);
exports.default = PaymentWizard;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PaymentWizard/PaymentWizard.jsx
// module id = 2382
// module chunks = 0